const testimonials = [
  {
    id: 1,
    name: '吃瓜小能手',
    role: '资深瓜友 · 3年用户',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20minimalist%20portrait%20silhouette%20with%20coral%20amber%20gradient%2C%20circular%20composition%2C%20soft%20glow%2C%20editorial%20style%2C%20clean%20design&width=80&height=80&seq=avatar-01&orientation=squarish',
    headline: '爆料又快又准，每天必刷！',
    content: '自从发现了吃瓜视频，再也不怕错过任何热点。网红翻车合集看得我停不下来，每天打开第一件事就是看看有没有新瓜。推荐给了身边所有朋友！',
    rating: 5,
  },
  {
    id: 2,
    name: '八卦研究员',
    role: '娱乐圈观察者',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20minimalist%20portrait%20silhouette%20with%20amber%20gradient%2C%20circular%20composition%2C%20soft%20glow%2C%20editorial%20style%2C%20clean%20design&width=80&height=80&seq=avatar-02&orientation=squarish',
    headline: '国产黑料一手掌握，资源太全了',
    content: '做娱乐自媒体三年了，吃瓜视频是我最信赖的素材来源。反差视频专区简直是宝藏，每次都能找到爆款选题灵感。',
    rating: 5,
  },
  {
    id: 3,
    name: '深夜吃瓜人',
    role: '忠实用户 · 1年',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20minimalist%20portrait%20silhouette%20with%20coral%20gradient%2C%20circular%20composition%2C%20soft%20glow%2C%20editorial%20style%2C%20clean%20design&width=80&height=80&seq=avatar-03&orientation=squarish',
    headline: '免费吃瓜视频，更新速度也太快了',
    content: '每天晚上睡前必逛的网站！明星八卦区的内容质量很高，不是那种标题党，每条都有实锤。吃瓜视频下载也很方便。',
    rating: 5,
  },
  {
    id: 4,
    name: '吃瓜不嫌事大',
    role: '活跃用户 · 2年',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20minimalist%20portrait%20silhouette%20with%20warm%20golden%20gradient%2C%20circular%20composition%2C%20soft%20glow%2C%20editorial%20style%2C%20clean%20design&width=80&height=80&seq=avatar-04&orientation=squarish',
    headline: '51吃瓜视频免费？原来是真的',
    content: '一开始以为是噱头，试了才发现真的全部免费！内容质量还这么高，网红翻车区的视频都是高清无码，看着太过瘾了。',
    rating: 5,
  },
  {
    id: 5,
    name: '追瓜第一线',
    role: '八卦爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20minimalist%20portrait%20silhouette%20with%20soft%20coral%20gradient%2C%20circular%20composition%2C%20soft%20glow%2C%20editorial%20style%2C%20clean%20design&width=80&height=80&seq=avatar-05&orientation=squarish',
    headline: '明星八卦一触即发，太刺激了',
    content: '娱乐圈有什么风吹草动，吃瓜视频总是第一个上。上次某顶流翻车事件，我比微博热搜还早三小时看到！这才是真正的独家爆料。',
    rating: 5,
  },
  {
    id: 6,
    name: '吃瓜群众代表',
    role: '新用户 · 3个月',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20minimalist%20portrait%20silhouette%20with%20warm%20amber%20gradient%2C%20circular%20composition%2C%20soft%20glow%2C%20editorial%20style%2C%20clean%20design&width=80&height=80&seq=avatar-06&orientation=squarish',
    headline: '吃瓜吃到饱，真的名不虚传',
    content: '朋友推荐来的，结果一发不可收拾。页面设计也很舒服，分类清晰，找视频特别方便。已经安利给整个群了！',
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section className="w-full py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 mb-4">
            <i className="ri-heart-line text-accent-600 text-sm"></i>
            <span className="text-accent-700 text-xs font-semibold">真实瓜友口碑</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            千万用户每日吃瓜
            <br />
            <span className="text-primary-500">真实评价一触即发</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            以下评价均来自吃瓜视频真实用户，口碑见证品质
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, idx) => (
            <article
              key={t.id}
              className="bg-background-50 rounded-2xl p-5 md:p-6 flex flex-col transition-all duration-300 hover:bg-background-50/90"
              style={{ opacity: idx === 5 ? 0.6 : 1 }}
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <h3 className="text-foreground-950 font-semibold text-sm mb-2">{t.headline}</h3>
              <p className="text-foreground-500 text-xs leading-relaxed mb-4 flex-1">{t.content}</p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-9 h-9 rounded-full object-cover object-top flex-shrink-0"
                  loading="lazy"
                />
                <div>
                  <p className="text-foreground-950 text-xs font-semibold">{t.name}</p>
                  <p className="text-foreground-500 text-xs">{t.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}